import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {ConfirmationService} from 'primeng/api';

import {EventService} from '../../../../core';
import {TokenService} from '../../../../core/auth';
import {User, UserApiKey} from '../../../../core/models';
import {UserService} from '../../../../core/services';

@Component({
  selector: 'app-user-api-key',
  templateUrl: './user-api-key.component.html'
})
export class UserApiKeyComponent implements OnInit {
  @Input() user: User;
  busy: boolean = true;
  displayDialog: boolean = false;
  apiKey: UserApiKey = null;
  showApiKey: boolean = false;

  constructor(
    private router: Router,
    private token: TokenService,
    private confirmationService: ConfirmationService,
    private eventService: EventService,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.userService.getApiKey(this.user.id).subscribe(
      (data) => {
        this.apiKey = data;
        this.busy = false;
      }
    );
  }

  toggleDialog() {
    this.displayDialog = !this.displayDialog;
  }

  resetApiKey() {
    this.confirmationService.confirm({
      message: 'Once reset an api key cannot be recovered. Are you sure that you want to perform this action?',
      accept: () => {
        this.busy = true;
        this.userService.resetApiKey(this.user.id).subscribe(
            (data) => {
              this.apiKey = data;
              this.busy = false;
            }
        );
      }
    });
  }

  hideDisplayApiKey() {
    this.showApiKey = false;
  }

  showDisplayApiKey() {
    this.showApiKey = true;
  }

  cancel() {
    this.displayDialog = false;
    this.showApiKey = false;
  }

}
